// extracted by mini-css-extract-plugin
export default {"button":"TableHoverActionsPlugin_button__3mijg","columnButton":"TableHoverActionsPlugin_columnButton__pYwjQ"};